import { Form, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Radio from 'components/Form/RadioButton'
import TextArea from 'components/Form/TextArea'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import { FormItem, RadioGroup } from 'components/UIComponents/FormStyles'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import { EmptyWrapper } from 'modules/Drives/Components/Styles/style'
import DriveStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import ScoreRadioButton from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/ScoreRadioButton'
import UpdateOnHold from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/UpdateOnHold'
import UpdateRejected from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/UpdateReject'
import UpdateSelected from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/UpdateSelect'
import {
  CommonDiv,
  DetailsDiv,
  Divider,
  FlexWrapper,
  FooterFlex,
  InterviewerDiv,
  ListInterviwer,
  NameWrapper,
  Padding,
  RoundDiv,
  RoundNameFlex,
  Roundname,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/style'
import { HeadText } from 'modules/Drives/ViewDriveRole/Style/style'
import React, { Fragment, useEffect, useState } from 'react'
import SuccessMessage from 'utils/SuccessMessage'
import { getIdFormate, getZeroBeforeInt } from 'utils/getZeroBeforeInt'

const UpdateStatus = ({
  updateStatus,
  setUpadateStatus,
  isGroup = false,
  candidateInfoData,
  interviwerDeatils,
  rolesMetrics,
  candidateInterviewDetails,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  expandandedRow,
  stage,
  groupCandidateList,
  setCandidateInfoData,
  loading,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
  getCandidatesList,
}) => {
  const [form] = Form.useForm()
  const [value, setValue] = useState('')
  const [showForm, setShowForm] = useState(isGroup)

  const [currentRound, setCurrentRound] = useState({})
  const [roundOrder, setRoundOrder] = useState(0)
  const [interViewer, setInterViewer] = useState([])
  const [feedbackList, setFeedbackList] = useState([
    currentRound?.interview?.interviewType
      ? {
          type: '',
          value: '',
        }
      : {
          type: '',
          value: '',
          qp: '',
        },
  ])

  const [strength, setStrength] = useState([])
  const [weakness, setWeakness] = useState([])
  const [selectedReason, setSelectedReason] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleStatus = e => {
    setValue(e.target.value)
  }

  const onUpdateStaus = record => {
    setShowForm(false)
    setCandidateInfoData(record)
  }

  useEffect(() => {
    setFeedbackList([
      currentRound?.interview?.interviewType !== 'ASSESMENT'
        ? {
            type: '',
            value: '',
          }
        : {
            type: '',
            value: '',
            qp: '',
          },
    ])
  }, [currentRound])

  useEffect(() => {
    form.setFieldsValue({
      feedback: feedbackList,
    })
  }, [feedbackList])

  useEffect(() => {
    form.setFieldsValue({
      strength: strength,
    })
  }, [strength])

  useEffect(() => {
    form.setFieldsValue({
      weakness: weakness,
    })
  }, [weakness])

  useEffect(() => {
    form.setFieldsValue({
      remark: selectedReason,
    })
  }, [selectedReason])

  useEffect(() => {
    let names = rolesMetrics[0]?.rounds?.map(({ roundName }, index) => {
      return roundName
    })
    setRoundOrder(
      names?.indexOf(
        candidateInfoData?.stage ? candidateInfoData?.stage : stage
      )
    )
  }, [candidateInfoData, rolesMetrics, stage])

  useEffect(() => {
    let roundInfo =
      candidateInterviewDetails?.candidateInterviewDetails?.filter(
        data => data?.interview?.interviewRound === candidateInfoData?.stage
      )[0]
    setCurrentRound(roundInfo)
  }, [candidateInterviewDetails, candidateInfoData])

  useEffect(() => {
    let panelListId = currentRound?.panel?.map(data => data?.id)
    const schedulerData = interviwerDeatils?.filter(data => {
      if (panelListId?.includes(data?._id)) {
        return data
      }
    })

    setInterViewer(
      isGroup
        ? interviwerDeatils
        : panelListId?.length > 0 && panelListId[0]
        ? schedulerData
        : 'NA'
    )
  }, [isGroup, interviwerDeatils, currentRound])

  const onSubmitFormData = async values => {
    setIsLoading(true)
    let payload = {
      interviewRound: candidateInfoData?.stage,
      results: [
        {
          studentId: candidateInfoData?.student?.id,
          status: values?.status,
          feedback: values?.feedback,
          strength: Array.isArray(values?.strength)
            ? values?.strength?.join(',')
            : values?.strength,
          weakness: Array.isArray(values?.weakness)
            ? values?.weakness?.join(',')
            : values?.weakness,
          comment: values?.comment,
          remark: values?.remark,
        },
      ],
    }

    let response = await updateInterviewStatus(driveId, roleId, payload)
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Status updated sucessfully!')
      setIsLoading(false)
      getCandidateList()
      form.resetFields()
      setFeedbackList([
        currentRound?.interview?.interviewType !== 'ASSESMENT'
          ? {
              type: '',
              value: '',
            }
          : {
              type: '',
              value: '',
              qp: '',
            },
      ])
      setStrength([])
      setWeakness([])
      setSelectedReason('')
      getRoleMetrics(driveId, roleId)
      setSelectedCandidate([])
      setSelectedCandidateId([])
      getSingleCandidateInterviewDetails(
        roleId,
        driveId,
        candidateInfoData?.student?.id
      )
      if (isGroup) {
        setShowForm(true)
        getCandidatesList()
      } else {
        setUpadateStatus(false)
      }
    } else {
      ErrorMessage(response?.response?.data?.message)
      setIsLoading(false)
    }
  }

  const candidateColumns = [
    {
      title: 'Candidate Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (_, rowData) => {
        let name =
          rowData?.student?.firstName + ' ' + rowData?.student?.lastName

        return (
          <FlexWrap alignCenter gap="8px">
            <RowNumberData>
              {rowData?.student?.firstName
                ? `${
                    (name?.length > 16
                      ? name?.substring(0, 16) + '..'
                      : name) || '-'
                  }`
                : 0}
            </RowNumberData>
          </FlexWrap>
        )
      },
    },

    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => <DriveStatus status={status} />,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (_, record) =>
        record?.status === 'REJECTED' ? (
          '-'
        ) : (
          <Button.Secondary
            height={'33px'}
            text={'Update Status'}
            onClick={() => onUpdateStaus(record)}
          />
        ),
    },
  ]

  const statusOptions = [
    {
      id: 1,
      label: 'Selected',
      value: 'SHORTLISTED',
    },
    {
      id: 2,
      label: 'On-Hold',
      value: 'HOLD',
    },
    {
      id: 3,
      label: 'Rejected',
      value: 'REJECTED',
    },
  ]

  const content = () => {
    return (
      <>
        <RoundNameFlex column>
          <RoundDiv>Round {getZeroBeforeInt(roundOrder + 1)}</RoundDiv>
          <Roundname>
            {candidateInfoData?.stage ? candidateInfoData?.stage : stage}
          </Roundname>
        </RoundNameFlex>

        <CommonDiv>
          <Flex>
            {showForm && (
              <Fragment>
                <Flex column>
                  <InterviewerDiv>Group ID</InterviewerDiv>
                  <ListInterviwer>
                    {getIdFormate(expandandedRow?.groupId)}
                  </ListInterviwer>
                </Flex>
                <Divider />
                <Flex column>
                  <InterviewerDiv>Total Candidates</InterviewerDiv>
                  <ListInterviwer>
                    {getZeroBeforeInt(expandandedRow?.candidates)}
                  </ListInterviwer>
                </Flex>
                <Divider />
              </Fragment>
            )}
            <Flex column>
              <InterviewerDiv>Interviewer</InterviewerDiv>

              {Array.isArray(interViewer) ? (
                interViewer?.length === 1 ? (
                  <FlexWrapper center>
                    <AntdAvatar
                      size={29}
                      IconName={interViewer[0]?.first_name?.charAt(0)}
                    />
                    <NameWrapper>
                      {interViewer[0]?.first_name} {interViewer[0]?.last_name}
                    </NameWrapper>
                  </FlexWrapper>
                ) : (
                  <FlexWrapper>
                    {interViewer.slice(0, 2).map((inter, index) => {
                      return (
                        <Padding key={index + inter?.first_name}>
                          <AntdAvatar
                            size={29}
                            IconName={inter?.first_name?.charAt(0)}
                          />
                        </Padding>
                      )
                    })}
                    {interViewer?.length > 2 && (
                      <Padding>
                        <AntdAvatar
                          size={29}
                          IconName={`+${interViewer?.length - 2}`}
                        />
                      </Padding>
                    )}
                  </FlexWrapper>
                )
              ) : (
                <ListInterviwer>{interViewer}</ListInterviwer>
              )}
            </Flex>
          </Flex>
        </CommonDiv>

        {showForm && (
          <CommonDiv>
            <StyledTable
              rowKey="id"
              columns={candidateColumns}
              dataSource={groupCandidateList}
              pagination={false}
              expandedRowPafalsedding={'16px'}
              locale={{
                emptyText: (
                  <EmptyWrapper column alignCenter isSpin={loading}>
                    {!loading ? (
                      <Flex column alignCenter>
                        <Flex>
                          <EmptyCandidateIcon />
                        </Flex>
                        <HeadText>No candidates found in this round</HeadText>
                      </Flex>
                    ) : (
                      <Spin />
                    )}
                  </EmptyWrapper>
                ),
              }}
            />
          </CommonDiv>
        )}
        <Form
          scrollToFirstError
          onFinish={onSubmitFormData}
          id={'updateForm'}
          form={form}
          layout="vertical"
          initialValues={{
            feedback: feedbackList,
          }}
        >
          {!showForm && (
            <Fragment>
              <CommonDiv>
                <ScoreRadioButton
                  feedbackList={feedbackList}
                  setFeedBackList={setFeedbackList}
                  interviewType={currentRound?.interview?.interviewType}
                />
              </CommonDiv>

              <CommonDiv column>
                <InterviewerDiv>Status</InterviewerDiv>
                <FormItem
                  name={'status'}
                  rules={[
                    {
                      required: true,
                      message: 'Please select the status!',
                    },
                  ]}
                >
                  <RadioGroup
                    spaceBetween
                    onChange={handleStatus}
                    value={value}
                  >
                    {statusOptions?.map(
                      (item, index) =>
                        candidateInfoData?.status !== item?.value && (
                          <Radio
                            width={'50%'}
                            key={index + item?.label}
                            border={true}
                            label={item?.label}
                            value={item?.value}
                          />
                        )
                    )}
                  </RadioGroup>
                </FormItem>
              </CommonDiv>

              <Flex>
                {value == 'SHORTLISTED' && (
                  <CommonDiv>
                    <UpdateSelected
                      strength={strength}
                      setStrength={setStrength}
                      weakness={weakness}
                      setWeakness={setWeakness}
                    />
                  </CommonDiv>
                )}
                {value == 'HOLD' && (
                  <CommonDiv>
                    <FormItem
                      name={'remark'}
                      rules={[
                        {
                          required: true,
                          message: 'Please select the remark!',
                        },
                      ]}
                    >
                      <UpdateOnHold
                        selectedReason={selectedReason}
                        setSelectedReason={setSelectedReason}
                      />
                    </FormItem>
                  </CommonDiv>
                )}
                {value == 'REJECTED' && (
                  <CommonDiv>
                    <FormItem
                      name={'remark'}
                      rules={[
                        {
                          required: true,
                          message: 'Please select the remark!',
                        },
                      ]}
                    >
                      <UpdateRejected
                        selectedReason={selectedReason}
                        setSelectedReason={setSelectedReason}
                      />
                    </FormItem>
                  </CommonDiv>
                )}
              </Flex>

              <FormItem>
                <DetailsDiv>Comment</DetailsDiv>
                <TextArea
                  placeholder="Add comment"
                  name={'comment'}
                  rules={[
                    {
                      required: true,
                      message: 'Please add the comment!',
                    },
                  ]}
                />
              </FormItem>
            </Fragment>
          )}
        </Form>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          text="Cancel"
          width="88px"
          height="38px"
          onClick={() => {
            setUpadateStatus(false)
            form.resetFields()
          }}
        />
        {!showForm && (
          <Button.Primary
            text="Submit"
            width="89px"
            height="38px"
            htmlType={'submit'}
            form={'updateForm'}
          />
        )}
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Update status'}
      placement="right"
      visible={updateStatus}
      content={content()}
      footer={footer()}
      onClose={() => {
        setUpadateStatus(false)
        form.resetFields()
      }}
      closable
      loading={isLoading}
    />
  )
}

export default UpdateStatus
